<script>
import cloneDeep from 'lodash.clonedeep'
import isEqual from 'lodash.isequal'
import uid from '../mixins/uid'

export default {
    name: 'InputCheckbox',

    mixins: [uid],

    props: {
        value: null,
        data: null,
        hintText: null,
        checked: null,
        content: null,
        trackBy: String,
        required: Boolean,
        disabled: Boolean,
        readonly: Boolean,
        switcher: Boolean,
        block: Boolean,
    },

    data() {
        return {
            innerValue: [],
            innerError: null,
            type: 'checkbox',
        }
    },

    computed: {
        innerChecked() {
            return typeof this.checked === 'boolean'
                ? this.checked
                : this.innerValue && this.data
                ? this.innerValue.some((el) =>
                      this.trackBy
                          ? isEqual(el[this.trackBy], this.data[this.trackBy])
                          : isEqual(el, this.data)
                  )
                : typeof this.innerValue === 'boolean'
                ? this.innerValue
                : null
        },
        innerContent() {
            return `${this.content}${this.required ? '<sup>*</sup>' : ''}`
        },
    },

    watch: {
        value: {
            immediate: true,
            handler(val) {
                if (val === undefined) {
                    val = false
                }
                this.innerValue = val
            },
        },
    },

    methods: {
        toggle() {
            if (!this.disabled && !this.readonly) {
                let innerValue = cloneDeep(this.innerValue)
                if (typeof innerValue === 'boolean') {
                    innerValue = !innerValue
                } else if (this.data) {
                    if (this.innerChecked) {
                        const index = this.trackBy
                            ? innerValue.findIndex(
                                  (el) => el[this.trackBy] === this.data[this.trackBy]
                              )
                            : innerValue.indexOf(this.data)
                        innerValue.splice(index, 1)
                    } else {
                        innerValue.push(this.data)
                    }
                }
                this.$emit('input', innerValue)
            }
        },
    },
}
</script>

<template lang="pug">
.checkbox-wrapper(tabindex="0" role="checkbox" @click.stop="toggle"  :id="uid" :class="[ {'switch': switcher, 'checked': innerChecked, 'disabled': disabled, 'readonly': readonly, 'error': innerError, 'd-block' : block}]")
    .checkbox
        span.checkbox-icon
            transition(name="fade-checkbox" v-if="!switcher")
                icon(icon="fa-solid fa-check")

        small.checkbox-text(v-if="content" v-html="innerContent")
        small.checkbox-text(v-else-if="$slots.default")
            slot
        sup(v-if="required && !content") *

    .hint(v-if="hintText" :class="{ 'text-error': hasError }")
        | {{ hintText }}

</template>
